import { styled } from "@mui/system";
import { MaterialDesignContent } from "notistack";

const SnackbarsCustomStyle = styled(MaterialDesignContent)(() => ({
	"&.notistack-MuiContent-error": {
		backgroundColor: "#ffffff",
		padding: "4px 16px 4px 16px",
		borderRadius: "10px",
		color: "#DE4759",
		boxShadow: "0px 2px 8px 0px #00000040",
		minHeight: "48px",
		maxWidth: "568px",
	},
	"&.notistack-MuiContent-error:after": {
		content: `''`,
		height: "1px",
		width: "0%",
		backgroundColor: "#DE4759",
		position: "absolute",
		bottom: "0",
		left: "0.5%",
		border: "0px solid #DE4759",
		borderBottomLeftRadius: "10px",
		animation: "growBottom 5s linear",
		animationDelay: "1s",
		animationFillMode: "forwards",
	},
	"@keyframes growBottom": {
		"0%": {
			borderWidth: "2px",
			width: "0",
		},
		"95%": {
			borderBottomRightRadius: "0px",
			borderWidth: "2px",
			width: "95%",
		},
		"100%": {
			borderBottomRightRadius: "10px",
			borderWidth: "2px",
			width: "99%",
		},
	},
	"&.notistack-MuiContent-error notistack-snackbar": {
		padding: "0",
	},
	"&.notistack-MuiContent-error .snackbars-content": {
		maxWidth: "300px",
	},
	"&.notistack-MuiContent-error .snackbars-critical": {
		fontWeight: "bold",
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
		marginRight: "4px",
	},
	"&.notistack-MuiContent-error .snackbars-message": {
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
	},
	"&.notistack-MuiContent-error .snackbars-actions": {
		color: "#B3B3B3",
	},
	"&.notistack-MuiContent-success": {
		backgroundColor: "#ffffff",
		padding: "4px 16px 4px 16px",
		borderRadius: "10px",
		color: "#009245",
		boxShadow: "0px 2px 8px 0px #00000040",
		minHeight: "48px",
		maxWidth: "568px",
	},
	"&.notistack-MuiContent-success:after": {
		content: `''`,
		height: "1px",
		width: "0%",
		backgroundColor: "#009245",
		position: "absolute",
		bottom: "0",
		left: "0.5%",
		borderBottomLeftRadius: "10px",
		border: "0px solid #009245",
		animation: "growBottom 5s linear",
		animationDelay: "1s",
		animationFillMode: "forwards",
	},
	"&.notistack-MuiContent-success notistack-snackbar": {
		padding: "0",
	},
	"&.notistack-MuiContent-success .snackbars-content": {
		maxWidth: "300px",
	},
	"&.notistack-MuiContent-success .snackbars-critical": {
		fontWeight: "bold",
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
		marginRight: "4px",
	},
	"&.notistack-MuiContent-success .snackbars-message": {
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
	},
	"&.notistack-MuiContent-success .snackbars-actions": {
		color: "#B3B3B3",
	},

	// Warning
	"&.notistack-MuiContent-warning": {
		backgroundColor: "#ffffff",
		padding: "4px 16px 4px 16px",
		borderRadius: "10px",
		color: "#FFB507",
		boxShadow: "0px 2px 8px 0px #00000040",
		minHeight: "48px",
		maxWidth: "568px",
	},
	"&.notistack-MuiContent-warning:after": {
		content: `''`,
		height: "1px",
		width: "0%",
		backgroundColor: "#FFB507",
		position: "absolute",
		bottom: "0",
		left: "0.5%",
		borderBottomLeftRadius: "10px",
		border: "0px solid #FFB507",
		animation: "growBottom 5s linear",
		animationDelay: "1s",
		animationFillMode: "forwards",
	},
	"&.notistack-MuiContent-warning notistack-snackbar": {
		padding: "0",
	},
	"&.notistack-MuiContent-warning .snackbars-content": {
		maxWidth: "568px",
	},
	"&.notistack-MuiContent-warning .snackbars-critical": {
		fontWeight: "bold",
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
		marginRight: "4px",
	},
	"&.notistack-MuiContent-warning .snackbars-message": {
		lineHeight: "1.2",
		fontSize: "14.5px",
		color: "#666666",
	},
	"&.notistack-MuiContent-warning .snackbars-actions": {
		color: "#B3B3B3",
	},
}));

export default SnackbarsCustomStyle;
